import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';


@Injectable()
export class CargasMasivasService
{
    constructor(private http: HttpClient) { }

    creaCargaMasiva(cargaMasiva: any)
    {
        let file:FormData = new FormData()
        file.append('file', cargaMasiva.archivo, cargaMasiva.archivo.name)
        return this.http.post(`${environment.urlApiCargas}/cargas/${cargaMasiva.tipoCarga}`, file,
        { headers: this.armaCabecera2() } ).toPromise()
    }

    traeCargas()
    {
        return this.http.get(`${environment.urlApiCargas}/cargas`, { headers: this.armaCabecera() } ).toPromise()
    }

    traeArchivoCarga(id: any)
    {
        return this.http.get(`${environment.urlApiCargas}/cargas/exportar/${id}`,
        { headers: this.armaCabecera(), responseType: 'arraybuffer' } ).toPromise()
    }

    reversaCargas(id: any, tipo: any)
    {
        return this.http.delete(`${environment.urlApiCargas}/cargas/${id}/tipo/${tipo}`,
        { headers: this.armaCabecera() } ).toPromise()
    }

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }

    armaCabecera2()
    {
        return new HttpHeaders({
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}
